import mixins from 'vue-typed-mixins';
import { AxiosResponse } from 'axios';
import _ from 'lodash';

import { Eユーザー権限 } from '@/openapi/enum';
import { ErrorResponse, ユーザーApi, ユーザーListItemResponse, ユーザーRequest } from '@/openapi/user';

import AlertMixin from '@/mixins/AlertMixin';
import RoutesMixin from '@/entries/user/mixins/RoutesMixin';
import 企業ユーザーMixin from '@/entries/user/mixins/企業ユーザーMixin';

import UserApiUtility from '@/classes/common/UserApiUtility';

type 入力ユーザー = Omit<ユーザーListItemResponse, 'cライセンス番号' | 'cユーザー権限' | 'c最終ログイン日時'> & {
  cライセンス番号?: number;
};

const initialEditユーザー = (): 入力ユーザー => {
  return {
    pk: 0,
    cユーザーメールアドレス: '',
    cユーザーパスワード: '',
    cユーザー名: '',
  };
};

export default mixins(AlertMixin, RoutesMixin, 企業ユーザーMixin).extend({
  name: 'Pライセンス',

  data(): {
    api: ユーザーApi;
    ユーザーs: ユーザーListItemResponse[];
    editユーザー: 入力ユーザー;
    eユーザー権限: typeof Eユーザー権限;
  } {
    return {
      api: UserApiUtility.ogApi(ユーザーApi),
      ユーザーs: [],
      editユーザー: initialEditユーザー(),
      eユーザー権限: Eユーザー権限,
    };
  },

  created(): void {
    this.$_load();
  },

  methods: {
    async $_load(): Promise<void> {
      const response = await this.api.listユーザー();
      this.ユーザーs = response.data;
    },

    clearForm() {
      this.editユーザー = initialEditユーザー();
    },

    isユーザー(ユーザー権限: Eユーザー権限): boolean {
      return ユーザー権限 === Eユーザー権限.ユーザー;
    },

    async save(): Promise<void> {
      // クライアント側で入力チェックをしたくないため、敢えてasを使用している
      const request = _.pick(this.editユーザー, [
        'cライセンス番号',
        'cユーザーメールアドレス',
        'cユーザーパスワード',
        'cユーザー名',
      ]) as ユーザーRequest;
      const response: AxiosResponse<void | ErrorResponse> = await this.api.createユーザー(request);
      if (this.isValidationErrorResponse(response)) return;
      this.$_clearAndLoad();
    },

    async remove(ユーザーpk: number): Promise<void> {
      const isCancelOrError = await this.isCancelOrValidationErrorResponseToDelete(() =>
        this.api.deleteユーザー(ユーザーpk)
      );
      if (isCancelOrError) return;
      this.$_clearAndLoad();
    },

    $_clearAndLoad() {
      this.clearForm();
      this.$_load();
    },
  },
});
